<!--收入证明-->
<template>
  <div class="employment">
    <toptitle :title1="titlework" />
    <section class="provetop">
      <section class="provesec"
               style="border: none">
        <div>
          <span>姓名</span>
        </div>
        <span class="arrow">{{ subBody.NAME }}</span>
      </section>
      <section class="provesec">
        <div>
          <span>身份证号</span>
        </div>
        <span class="arrow">{{ subBody.NATIONAL_ID }}</span>
      </section>
      <section class="provesec">
        <div>
          <span>入职日期</span>
        </div>
        <span class="arrow"> {{ subBody.LAST_HIRE_DT }}</span>
      </section>
      <section class="provesec">
        <div>
          <span>公司</span>
        </div>
        <div class="arrow">
          <van-cell is-link
                    @click="showPopup">{{ word }}</van-cell>
          <van-popup v-model="show">
            <van-picker title="请选择公司"
                        show-toolbar
                        :columns="columns"
                        @confirm="onConfirm"
                        @cancel="onCancel" />
          </van-popup>
        </div>
      </section>
      <section class="provesec">
        <div>
          <span>部门</span>
        </div>
        <span class="arrow">{{ subBody.DEPT_DESCR }}</span>
      </section>
      <section class="provesec">
        <div>
          <span>职位</span>
        </div>
        <span class="arrow">{{ subBody.POSN_DESCR }}</span>
      </section>
      <!-- <section class="provesec color">
        <div>
          <span>年收入</span>
        </div>
        <span class="arrow">由HR填写</span>
      </section> -->
      <section class="provesec">
        <div>
          <span>申请日期</span>
        </div>
        <span class="arrow"> {{ timenow | dataform }}</span>
      </section>
    </section>
    <section>

      <van-field v-model="COMMENTS"
                 label="备注"
                 :formatter="formatter"
                 autosize
                 type="textarea"
                 placeholder="请输入申请原因" />
    </section>
    <div class="submit"
         @click="submit">提交</div>
  </div>
</template>

<script>
import toptitle from '../toptitle'
import axios from 'axios'
import { GetWorkDataApi, postZmkjDataApi } from '../../request/api'
import { Toast } from 'vant'
import _ from 'lodash'
export default {
  name: 'residence',
  data() {
    return {
      titlework: '居住证明',
      subBody: [],
      timenow: '',
      show: false,
      columns: [],
      word: '请选择',
      currentDate: '',
      COMMENTS: '',
    }
  },
  methods: {
    /**
     * 格式化输入框
     *  **/
    formatter(value) {
      //过滤输入的特殊符号
      let reg = /[`~!@#$%^&*()_\-+=<>?:"{}|\/;'\\[\]·~！@#￥%……&*（）——\-+={}|《》？：“”【】、；‘]/gi
      if (reg.test(value)) {
        Toast.fail('请不要输入特殊字符')
      }
      return value.replace(
        /[`~!@#$%^&*()_\-+=<>?:"{}|\/;'\\[\]·~！@#￥%……&*（）——\-+={}|《》？：“”【】、；‘]/g,
        ''
      )
    },
    showPopup() {
      this.show = true
    },
    onConfirm(value, index) {
      this.word = value
      this.show = false
    },
    onCancel() {
      this.show = false
    },
    submit: _.throttle(function (event) {
      let companyDesc = ''
      for (let i = 0; i < this.subBody.COMPANY.length; i++) {
        if (this.word == this.subBody.COMPANY[i].NAME) {
          companyDesc = this.subBody.COMPANY[i].VALUE
        }
      }
      if (this.word == '请选择') {
        Toast.fail('请选择公司')
        return
      }
      if (this.COMMENTS.length < 1) {
        Toast.fail('备注信息不能为空')
        return
      }

      let prams = {
        EMPLID: this.subBody.EMPLID,
        applyData: this.currentDate,
        PROVETYPE: '30',
        COMPANY: companyDesc,
        COMMENTS: this.COMMENTS,
      }
      postZmkjDataApi(prams).then((res) => {
        if (res.CODE === '200') {
          Toast.success(res.MESSAGE)
          this.$router.push('/')
        } else {
          Toast(res.MESSAGE)
        }
      })
    }, 2000),
  },
  components: {
    toptitle,
  },
  /**
   * 收入证明初始化数据
   * **/
  created() {
    var s = new Date()
    var m = s.getMonth() + 1
    var d = s.getDate()
    if (m >= 1 && m <= 9) {
      m = '0' + m
    }
    if (d >= 0 && d <= 9) {
      d = '0' + d
    }
    this.currentDate = s.getFullYear() + '-' + m + '-' + d
    let params = {
      EMPLID: sessionStorage.getItem('EMPLID'),
    }
    GetWorkDataApi(params).then((res) => {
      console.log(res, 'res')
      if (res.CODE == 200) {
        this.subBody = res.DATA || {}

        let arr = this.subBody.COMPANY

        this.columns = arr.map((index) => {
          return index.NAME
        })
      } else if (res.CODE == 0) {
        Toast(res.MESSAGE)
      }
    })
  },
  filters: {
    dataform(val) {
      return val.slice(0, 10)
    },
  },
}
</script>

<style lang="less" scoped>
.provetop {
  background: white;
  margin: 10px 0px;
  border-top: 1px solid #e5e5e5;
  border-bottom: 1px solid #e5e5e5;
  .provesec {
    margin-left: 20px;
    display: flex;
    line-height: 44px;
    border-top: 1px solid #e5e5e5;
    div {
      img {
        height: 15px;
        width: 15px;
        margin-right: 10px;
      }
    }
    .arrow,
    input {
      flex: 1;
      text-align: right;
      margin-right: 20px;
      line-height: 44px;
      color: #c4c4c6;
    }
    input {
      // flex: 1;
      border: 0;
    }
  }
}
.submit {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 44px;
  background: #007fc6;
  color: white;
  line-height: 44px;
  text-align: center;
  font-size: 18px;
}
/deep/ .van-cell__value {
  text-align: right;
}
/deep/ .van-popup {
  width: 80%;
}
/deep/.van-cell {
  padding-right: 0;
}
</style>
